import { useRouterStore } from '~/stores/router'

export default defineNuxtRouteMiddleware((to, from) => {
  const { validateRouteChange } = useRouterStore()

  if (to.path !== from.path && !validateRouteChange(to.fullPath)) {
    return abortNavigation()
  }
})
